import { Outlet } from "react-router";

// import '@/modules/VU/layout/Validacion.layout.css';

export const ValidacionLayout = () => {
    return (
        <>
            <main className="flex flex-wrap items-center justify-center bg-gradient-to-b from-blue-50 to-white min-h-screen">
                <div className="w-11/12 max-w-4xl bg-white rounded-2xl shadow-lg p-8 text-center">
                    <div className="logo w-full flex justify-center mb-10">
                        <img src="/logo.svg" className="h-[120px]" alt="Poder Judicial - Acceso Digital" />
                    </div>
                    <Outlet/>
                    <p className="text-gray-700 mt-5">Su información será procesada de manera segura.</p>
                </div>
            </main>
        </> 
    );
}